import { render, staticRenderFns } from "./InvitationCode.vue?vue&type=template&id=c508a126&scoped=true&"
import script from "./InvitationCode.vue?vue&type=script&lang=js&"
export * from "./InvitationCode.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCode.vue?vue&type=style&index=0&id=c508a126&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c508a126",
  null
  
)

export default component.exports